import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-grid-03',
  standalone: true,
  templateUrl: './rt-icon-grid-03.component.html',
  styleUrls: ['./rt-icon-grid-03.component.scss']
})
export class RtIconGrid03Component {
  @Input() width: number | string = 15;
  @Input() height: number | string = 15;
}
